import axios from 'axios';

const api = axios.create({
    baseURL: 'https://api.atendimento.dommus.com.br'
});

export default api;
